import { useContext, useState } from "react";

import axios from "axios";

import { RECIPE_GENERATION_API } from "../app/constants/constants";
import { useAppSelector } from "../app/store/hooks";
import { ErrorManagementContext } from "../utils/errorManagement/ErrorManagementProvider";

const useGenerateRecipe = () => {
  const user = useAppSelector((state) => state.main.user);
  const [loading, setLoading] = useState(false);
  const [recipeId, setRecipeId] = useState<string | null>(null);
  const { cookClubLog } = useContext(ErrorManagementContext);

  const generateRecipe = async (recipeName: string) => {

    try {

      setLoading(true);
      const recipeGenerationResponse: any = await axios.post(RECIPE_GENERATION_API, {
        message: recipeName,
        userId: user?.id,
        saveRecipe: true
      }).catch((err) => {
        cookClubLog(` Try again`,
          "Error creating recipe!", {}, { ui: { type: "error" }, browserConsole: true })
        throw new Error('Error generating recipe', err);
      })
      setRecipeId(recipeGenerationResponse.data?.response?.recipeId ?? null);
      setLoading(false);
      return recipeGenerationResponse.data?.response?.recipeId;

    } catch (err) {
      setLoading(false);
      console.error(err)
      return null;

    }
  }

  return { loading, recipeId, generateRecipe };
}

export default useGenerateRecipe